import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

const masterCuisinesAPI = () => Http.masterGet(ApiRoutes.masterCuisines);
const languagesAPI = () => Http.masterGet(ApiRoutes.masterLanguages);
const slotsAPI = () => Http.masterGet(ApiRoutes.masterSlot);

export {
    masterCuisinesAPI,
    languagesAPI,
    slotsAPI
}